import React from 'react';

/** Lucide wheat-off — ISC, see `public/img-assets/wheat-off.svg`. */
export const ALLERGEN_ICON_SRC = '/img-assets/wheat-off.svg';

export const allergenIconImgFilterRed =
    'brightness(0) saturate(100%) invert(39%) sepia(70%) saturate(2051%) hue-rotate(353deg) brightness(95%) contrast(89%)';

export const allergenIconImgFilterGreen =
    'brightness(0) saturate(100%) invert(52%) sepia(86%) saturate(449%) hue-rotate(131deg) brightness(91%) contrast(101%)';

type AllergenIconImgVariant = 'red' | 'green';

type AllergenIconImgProps = {
    alt: string;
    width?: number;
    height?: number;
    className?: string;
    variant?: AllergenIconImgVariant;
};

export function AllergenIconImg({ alt, width, height, className, variant = 'red' }: AllergenIconImgProps) {
    const filter = variant === 'green' ? allergenIconImgFilterGreen : allergenIconImgFilterRed;
    return (
        <img
            className={className}
            src={ALLERGEN_ICON_SRC}
            alt={alt}
            width={width}
            height={height}
            style={{ display: 'block', filter }}
        />
    );
}

/** Lucide wheat-off paths — inline for print / iframe (no external asset fetch). */
export function AllergenIconPaths() {
    return (
        <>
            <path d="m2 22 10-10" />
            <path d="m16 8-1.17 1.17" />
            <path d="M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z" />
            <path d="m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97" />
            <path d="M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62" />
            <path d="M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z" />
            <path d="M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z" />
            <path d="m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98" />
            <path d="M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28" />
            <line x1="2" x2="22" y1="2" y2="22" />
        </>
    );
}

export const allergenIconInlineColor = 'var(--red_error)';

type AllergenIconInlineProps = {
    ariaLabel: string;
    /** CSS length (e.g. `11px`, `7pt`). */
    size?: string | number;
    className?: string;
};

/** Inline SVG so print iframe works without MUI global icon styles. */
export function AllergenIconInline({ ariaLabel, size = '1.1em', className }: AllergenIconInlineProps) {
    const dimension = typeof size === 'number' ? `${size}px` : size;
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={dimension}
            height={dimension}
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ color: allergenIconInlineColor }}
            aria-label={ariaLabel}
            role="img"
            focusable="false"
        >
            <title>{ariaLabel}</title>
            <AllergenIconPaths />
        </svg>
    );
}
